import * as React from 'react';

import { RadioButtonProps, RadioButtonOnClick } from './RadioButton';
import {
    RadioGroupContainer,
    RadioGroupFieldset,
    RadioGroupLegend,
    RadioGroupDescription,
    RadioGroupErrorMessage
} from './RadioButton.styles';

export type RadioGroupProps = {
    description?: string;
    errorMessage?: string;
    legend: string;
    radioGroupName: string;
    ref?: React.Ref<HTMLInputElement>;
    onClick?: RadioButtonOnClick;
};

export const RadioGroup: React.FC<React.PropsWithChildren<RadioGroupProps>> = ({
    children,
    description,
    errorMessage,
    legend,
    radioGroupName,
    onClick
}) => (
    <RadioGroupFieldset
        role="radiogroup"
        aria-labelledby={`${radioGroupName}-aria-labelledby`}
        aria-required="true"
    >
        <RadioGroupLegend
            size="7"
            as="legend"
            id={!description ? `${radioGroupName}-aria-labelledby` : ''}
            data-testid={`${radioGroupName}-legend`}
        >
            {legend}
        </RadioGroupLegend>
        {description && (
            <RadioGroupDescription
                id={`${radioGroupName}-aria-labelledby`}
                data-testid={`${radioGroupName}-description`}
            >
                {description}
            </RadioGroupDescription>
        )}
        <RadioGroupContainer>
            {React.Children.map(children, (child) => {
                return React.cloneElement(
                    child as React.ReactElement<RadioButtonProps>,
                    { errorMessage, name: radioGroupName, onClick }
                );
            })}
        </RadioGroupContainer>
        {errorMessage && (
            <RadioGroupErrorMessage
                aria-live="assertive"
                data-testid={`${radioGroupName}-error-message`}
                variant="invalid"
                message={errorMessage as string}
            />
        )}
    </RadioGroupFieldset>
);
